import { RootState } from '../../../../rootReducer';

export const importReportSelector = (state: RootState) => state.eventsLogModuleReducer.ImportReportCodesReducer;
